import SEO from './SEO'
import Facebook from './Facebook'

export { Facebook }

export default SEO
